<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- Encabezado -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Médicos</h4>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de médicos"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Médicos">
  <AyudaMedico />
</Modal>

    <hr>

    <!-- DataTable -->
    <DataTable
      :data="medicos"
      :columns="columnas"
      idField="idMedico"
      mensajeVacio="No se encontraron médicos."
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="true"
      @create="abrirAsistente"  
      @edit="row => abrirModalEditar(row.idMedico)"
      @delete="row => deleteMedico(row.idMedico)"
    >
      <template #cell-estado="{ row }">
        <span :class="row.estado == 1 ? 'badge bg-success' : 'badge bg-danger'">
          {{ row.estado == 1 ? 'Activo' : 'Inactivo' }}
        </span>
      </template>

      <!-- Doble click en fila → ir a agenda -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-primary"
          @click="abrirMedico(row.idPersona)"
          title="Ver Médico"
        >
          <span class="material-icons" style="font-size:14px">person</span>
        </button>
        <button
          class="btn btn-sm btn-outline-primary"
          @click="abrirEditar(row.idMedico)"
          title="Ver Agenda"
        >
          <span class="material-icons" style="font-size:14px">event</span>
        </button>
      </template>

    </DataTable>

    <!-- Modal: información del médico -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="modalMedicoLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="modalMedicoLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-2 row">
              <label class="col-3 col-form-label fw-bold">IdMedico</label>
              <div class="col-9"><span class="form-control-plaintext">{{ datoMedico.idMedico }}</span></div>
            </div>
            <div class="mb-2 row">
              <label class="col-3 col-form-label fw-bold">Persona</label>
              <div class="col-9"><span class="form-control-plaintext">{{ datoMedico.nombreCompleto }}</span></div>
            </div>
            <div class="mb-2 row">
              <label class="col-3 col-form-label fw-bold">Especialidad</label>
              <div class="col-9"><span class="form-control-plaintext">{{ datoMedico.especialidadNombre }}</span></div>
            </div>
            <div class="mb-2 row">
              <label class="col-3 col-form-label fw-bold">Documento Id.</label>
              <div class="col-9"><span class="form-control-plaintext">{{ datoMedico.personaDocumento }}</span></div>
            </div>
            <div class="mb-2 row">
              <label class="col-3 col-form-label fw-bold">Documento Médico</label>
              <div class="col-9"><span class="form-control-plaintext">{{ datoMedico.documento }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout      from '@/components/Layout.vue';
import Footer      from '@/components/Footer.vue';
import AyudaMedico from '@/views/ayuda/AyudaMedico.vue';
import DataTable   from '@/components/DataTable.vue';
import api    from '@/services/api';
import * as $ from 'jquery';
window['$']      = $;
window['jQuery'] = $;
import swal  from 'sweetalert';
import swal2 from 'sweetalert2';

export default {
  props: {
    p_idPersona: { type: String, required: true },
  },
  components: { Layout, Footer, AyudaMedico, DataTable },

  data() {
    return {
      medicos:          [],
      datoMedico:       {},
      titulo:           '',
      modalWindow:      true,
      showModalHelp:    false,
      imgStyle: {
        width:        '48px',
        height:       '48px',
        cursor:       'pointer',
        border:       '2px solid blue',
        borderRadius: '8px',
        display:      'block',
        transition:   'all 0.3s ease-in-out',
      },

      columnas: [
        { label: 'Documento',    field: 'personaDocumento' },
        { label: 'Nombre',       field: 'nombreCompleto' },
        {
          label: 'Especialidad',
          field: 'especialidadNombre',
          filterType: 'select',
          filterOptions: [],
        },
        {
          label: 'Estado',
          field: 'estado',
          filterType: 'select',
          filterOptions: [
            { label: 'Activo',   value: '1' },
            { label: 'Inactivo', value: '0' },
          ],
        },
      ],
    };
  },

  computed: {
    opcionesEspecialidad() {
      const set = new Set(this.medicos.map(m => m.especialidadNombre).filter(Boolean))
      return [...set].sort()
    },
  },

  watch: {
    opcionesEspecialidad(vals) {
      const col = this.columnas.find(c => c.field === 'especialidadNombre')
      if (col) col.filterOptions = vals
    },
  },

  mounted() {
    this.getDataTodos();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },

  methods: {
    //  Datos
    getDataTodos() {
      const idEmpresa = window.sessionStorage.getItem('idEmpresa');
      api.get(`/vwmedicos/idempresa/${idEmpresa}`)
        .then(resp => { this.medicos = resp.data.reverse(); })
        .catch(() => swal('Error', 'No se pudieron cargar los médicos.', 'error'));
    },

    //  Acciones
    abrirModalEditar(idMedico) {
      this.modalWindow = true;
      if (idMedico != null) {
        api.get(`/vwmedicos/${idMedico}`).then(resp => {
          this.datoMedico = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo = 'Información del Médico';
    },

    abrirMedico(idPersona) {
      if (idPersona != null) {
        this.$router.push('/personaform/M/' + idPersona);
      }
    },

    abrirEditar(idMedico) {
      if (idMedico != null) {
        this.$router.push('/medico_agenda/' + idMedico);
      }
    },

    async deleteMedico(idMedico) {
      try {
        await api.delete(`/medicos/${idMedico}`);
        this.getDataTodos();
      } catch {
        swal('Error', 'No se pudo eliminar el médico.', 'error');
      }
    },

    //  Asistente
    abrirAsistente() {
      const idEmpresa      = window.sessionStorage.getItem('idEmpresa');
      const idSuscripcion  = window.sessionStorage.getItem('idSuscripcion');
      api.get(`/usuarios/disponibles/${idEmpresa}/${idSuscripcion}`)
        .then(resp => {
          if (resp.data > 0) {
            this.$router.push('/medico01/0');
          } else {
            swal2.fire({
              title: 'Error!',
              text: 'No es posible crear más usuarios médicos. Actualice su plan de suscripción.',
              icon: 'error',
              confirmButtonText: 'Actualizar Plan',
              showCancelButton: true,
              cancelButtonText: 'Cancelar',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
            }).then(result => {
              if (result.isConfirmed) {
                this.$router.push('/empresaform/' + idEmpresa);
              } else {
                swal2.fire('Actualización Pendiente', 'Para crear más usuarios, actualice su plan.', 'info');
              }
            });
          }
        })
        .catch(err => {
          console.error(err);
          swal('Error!', 'Problema al obtener la cantidad de usuarios.', 'error');
        });
    },

    //  Imagen hover
    hoverEffect(isHovering) {
      this.imgStyle.filter    = isHovering ? 'brightness(1.2)' : '';
      this.imgStyle.transform = isHovering ? 'scale(1.1)'      : '';
    },
  },
};
</script>

<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
img:hover {
  border-color: rgb(253, 209, 13);
  box-shadow: 0 0 10px 2px rgb(253, 209, 13);
}
</style>